import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { select, Store } from '@ngrx/store';
import { ResetPassword } from '../../../models/reset-password';
import { AlertaService } from '../../../services/alerta.service';
import { ResetPasswordService } from '../../../services/reset-password.service';
import { updateResetPasswordAct } from '../../../store/reset-password/reset-password.actions';
import { distinctUntilChanged, map } from 'rxjs';

@Component({
  selector: 'app-password-recovery',
  standalone: false,
  templateUrl: './password-recovery.component.html',
  styleUrl: './password-recovery.component.css'
})
export class PasswordRecoveryComponent {

  form: FormGroup;
  resetPassword: ResetPassword;
  loading: boolean = false;

  constructor(
    //private store: Store<{ catalogOfferRdc: any }>,
    private resetPasswordRdcStore: Store<{ resetPasswordRdc: any }>,
    private route: ActivatedRoute,
    private resetPasswordService: ResetPasswordService,
    private fb: FormBuilder,
    private router: Router,
    private alerta: AlertaService
  ) {
    this.resetPassword = new ResetPassword();
    this.form = this.fb.group({
      email: [''],
      password: [''],
      confirmPassword: ['']
    },
      {
        validators: this.passwordsMatchValidator
      });

    this.resetPasswordRdcStore.pipe(
      select('resetPasswordRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ loading }) => {
      this.loading = loading;
    });
  }

  ngOnInit(): void {
    this.loading =  true;
    const token = this.route.snapshot.paramMap.get('token'); // obtenemos el UUID
    const fechaActual = new Date();
    if (token) {
      this.resetPasswordService.findResetPasswordByToken(token).subscribe({ //data => {
        next: (data) => {
        const expirationDate = new Date(data.expirationDate);
        if (data.used === false && expirationDate > fechaActual) {
          this.resetPassword.email = data.email;
          this.resetPassword.id = data.id;
          this.form.patchValue({
            email: data.email
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.alerta.information('La solicitud ha expirado');
          this.router.navigate(['/login']);
        }
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else if(err.status == 404){
          this.alerta.error("No se tiene registrada la solicitud para cambio de contraseña: ");
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
      });
    }else{
      this.router.navigate(['/login']);
    }
  }

  onSubmit() {
    if (this.form.invalid) return;

    this.resetPassword.newPassword = this.form.value.password;
    this.resetPassword.isUpdate = true;
    this.resetPassword.active = false;
    this.resetPassword.used = true;
    //console.log(this.resetPassword);

    this.resetPasswordRdcStore.dispatch(updateResetPasswordAct({
      resetPasswordUpdated: this.resetPassword
    }));
    //this.alerta.correct('Contraseña actualizada correctamente.');
    //this.router.navigate(['/login']);
  }

  onCancel() {
    this.router.navigate(['/login']);
  }

  passwordsMatchValidator(group: FormGroup): { [key: string]: any } | null {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordsMismatch: true };
  }
}